import { render } from "./ImgBanner.vue?vue&type=template&id=630fb432&scoped=true"
const script = {}

import "./ImgBanner.vue?vue&type=style&index=0&id=630fb432&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630fb432"]])

export default __exports__